import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function ChangePassword() {
  const { user, refresh, logout } = useAuth();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const forced = sp.get("forced") === "1";

  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  if (!user) return null;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (next.length < 8) { setErr("La nueva contraseña debe tener al menos 8 caracteres."); return; }
    if (next !== confirm) { setErr("Las contraseñas no coinciden."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      await refresh();
      setDone(true);
      setTimeout(() => navigate("/", { replace: true }), 1200);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gb-bg text-gb-black">
      <header className="border-b border-gb-paper bg-gb-surface">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
          <Link to="/" className="text-[11px] uppercase tracking-[0.35em] text-stone-600 transition hover:text-gb-red">← grabarte studio</Link>
          <button onClick={logout} className="text-[11px] uppercase tracking-[0.3em] text-stone-500 transition hover:text-gb-red">Cerrar sesión</button>
        </div>
      </header>

      <main className="mx-auto max-w-md px-6 py-12" data-testid="change-password-page">
        <p className="gb-eyebrow">Seguridad</p>
        <h1 className="mt-2 gb-display text-3xl">
          {forced ? "Crea tu contraseña" : "Cambiar contraseña"}
        </h1>
        {forced && (
          <p className="mt-3 rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-800" data-testid="forced-notice">
            Como es tu primer acceso (o el administrador ha restablecido tu contraseña), debes elegir una nueva antes de continuar.
          </p>
        )}

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-[11px] uppercase tracking-[0.3em] text-stone-500">Contraseña actual</label>
            <input type="password" autoComplete="current-password" required
                   value={current} onChange={(e) => setCurrent(e.target.value)}
                   data-testid="cp-current"
                   className="mt-2 w-full rounded-md border border-gb-paper bg-white px-3 py-2 outline-none transition focus:border-gb-red" />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-[0.3em] text-stone-500">Nueva contraseña (mín. 8)</label>
            <input type="password" autoComplete="new-password" required
                   value={next} onChange={(e) => setNext(e.target.value)}
                   data-testid="cp-new"
                   className="mt-2 w-full rounded-md border border-gb-paper bg-white px-3 py-2 outline-none transition focus:border-gb-red" />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-[0.3em] text-stone-500">Confirma la nueva contraseña</label>
            <input type="password" autoComplete="new-password" required
                   value={confirm} onChange={(e) => setConfirm(e.target.value)}
                   data-testid="cp-confirm"
                   className="mt-2 w-full rounded-md border border-gb-paper bg-white px-3 py-2 outline-none transition focus:border-gb-red" />
          </div>

          {err && <p className="rounded bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="cp-error">{err}</p>}
          {done && <p className="rounded bg-emerald-50 px-3 py-2 text-sm text-emerald-700" data-testid="cp-ok">Contraseña actualizada. Redirigiendo…</p>}

          <button type="submit" disabled={busy} data-testid="cp-submit"
                  className="w-full rounded-full bg-gb-red px-5 py-2.5 text-sm font-semibold uppercase tracking-widest text-white transition hover-gb-red disabled:opacity-40">
            {busy ? "Guardando…" : "Actualizar contraseña"}
          </button>
        </form>
      </main>
    </div>
  );
}
